/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineBookingPrepaymentDto } from './traveline-booking-prepayment-dto';
import {
    TravelineBookingPrepaymentDtoFromJSON,
    TravelineBookingPrepaymentDtoFromJSONTyped,
    TravelineBookingPrepaymentDtoToJSON,
    TravelineBookingPrepaymentDtoToJSONTyped,
} from './traveline-booking-prepayment-dto';
import type { TravelineBookingServiceRqDto } from './traveline-booking-service-rq-dto';
import {
    TravelineBookingServiceRqDtoFromJSON,
    TravelineBookingServiceRqDtoFromJSONTyped,
    TravelineBookingServiceRqDtoToJSON,
    TravelineBookingServiceRqDtoToJSONTyped,
} from './traveline-booking-service-rq-dto';
import type { TravelineBookingRoomStayRqDto } from './traveline-booking-room-stay-rq-dto';
import {
    TravelineBookingRoomStayRqDtoFromJSON,
    TravelineBookingRoomStayRqDtoFromJSONTyped,
    TravelineBookingRoomStayRqDtoToJSON,
    TravelineBookingRoomStayRqDtoToJSONTyped,
} from './traveline-booking-room-stay-rq-dto';
import type { TravelineBookingCustomerDto } from './traveline-booking-customer-dto';
import {
    TravelineBookingCustomerDtoFromJSON,
    TravelineBookingCustomerDtoFromJSONTyped,
    TravelineBookingCustomerDtoToJSON,
    TravelineBookingCustomerDtoToJSONTyped,
} from './traveline-booking-customer-dto';

/**
 * Booking
 * @export
 * @interface TravelineBookingRqDto
 */
export interface TravelineBookingRqDto {
    /**
     * Property ID
     * @type {string}
     * @memberof TravelineBookingRqDto
     */
    propertyId: string;
    /**
     * List of stays
     * @type {Array<TravelineBookingRoomStayRqDto>}
     * @memberof TravelineBookingRqDto
     */
    roomStays: Array<TravelineBookingRoomStayRqDto>;
    /**
     * Extra services<br />
     * Services with a payment type ’Per Booking’ (ChargeType = PerReservation) are available here
     * @type {Array<TravelineBookingServiceRqDto>}
     * @memberof TravelineBookingRqDto
     */
    services?: Array<TravelineBookingServiceRqDto> | null;
    /**
     * 
     * @type {TravelineBookingCustomerDto}
     * @memberof TravelineBookingRqDto
     */
    customer: TravelineBookingCustomerDto;
    /**
     * 
     * @type {TravelineBookingPrepaymentDto}
     * @memberof TravelineBookingRqDto
     */
    prepayment?: TravelineBookingPrepaymentDto;
    /**
     * Agent comments on the booking<br />
     * Maximum number of comments: 5 по 250 characters
     * @type {Array<string>}
     * @memberof TravelineBookingRqDto
     */
    bookingComments?: Array<string> | null;
}

/**
 * Check if a given object implements the TravelineBookingRqDto interface.
 */
export function instanceOfTravelineBookingRqDto(value: object): value is TravelineBookingRqDto {
    if (!('propertyId' in value) || value['propertyId'] === undefined) return false;
    if (!('roomStays' in value) || value['roomStays'] === undefined) return false;
    if (!('customer' in value) || value['customer'] === undefined) return false;
    return true;
}

export function TravelineBookingRqDtoFromJSON(json: any): TravelineBookingRqDto {
    return TravelineBookingRqDtoFromJSONTyped(json, false);
}

export function TravelineBookingRqDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingRqDto {
    if (json == null) {
        return json;
    }
    return {
        
        'propertyId': json['propertyId'],
        'roomStays': ((json['roomStays'] as Array<any>).map(TravelineBookingRoomStayRqDtoFromJSON)),
        'services': json['services'] == null ? undefined : ((json['services'] as Array<any>).map(TravelineBookingServiceRqDtoFromJSON)),
        'customer': TravelineBookingCustomerDtoFromJSON(json['customer']),
        'prepayment': json['prepayment'] == null ? undefined : TravelineBookingPrepaymentDtoFromJSON(json['prepayment']),
        'bookingComments': json['bookingComments'] == null ? undefined : json['bookingComments'],
    };
}

  export function TravelineBookingRqDtoToJSON(json: any): TravelineBookingRqDto {
      return TravelineBookingRqDtoToJSONTyped(json, false);
  }

  export function TravelineBookingRqDtoToJSONTyped(value?: TravelineBookingRqDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'propertyId': value['propertyId'],
        'roomStays': ((value['roomStays'] as Array<any>).map(TravelineBookingRoomStayRqDtoToJSON)),
        'services': value['services'] == null ? undefined : ((value['services'] as Array<any>).map(TravelineBookingServiceRqDtoToJSON)),
        'customer': TravelineBookingCustomerDtoToJSON(value['customer']),
        'prepayment': TravelineBookingPrepaymentDtoToJSON(value['prepayment']),
        'bookingComments': value['bookingComments'],
    };
}

